import { render, staticRenderFns } from "./CommonCountCard.vue?vue&type=template&id=70b84ca0&scoped=true"
import script from "./CommonCountCard.vue?vue&type=script&lang=js"
export * from "./CommonCountCard.vue?vue&type=script&lang=js"
import style0 from "./CommonCountCard.vue?vue&type=style&index=0&id=70b84ca0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b84ca0",
  null
  
)

export default component.exports